import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(4)">
      <path
        d="M21,12 L20,12 L20,8 C20,3.581722 16.418278,2.705415e-16 12,0 C7.581722,-2.705415e-16 4,3.581722 4,8 L4,12 L3,12 C1.34314575,12 -1.77635684e-15,13.3431458 -1.77635684e-15,15 L-1.77635684e-15,29 C-1.77635684e-15,30.6568542 1.34314575,32 3,32 L21,32 C22.6568542,32 24,30.6568542 24,29 L24,15 C24,13.3431458 22.6568542,12 21,12 Z M6,8 C6,4.6862915 8.6862915,2 12,2 C15.3137085,2 18,4.6862915 18,8 L18,12 L6,12 L6,8 Z M22,29 C22,29.5522847 21.5522847,30 21,30 L3,30 C2.44771525,30 2,29.5522847 2,29 L2,15 C2,14.4477153 2.44771525,14 3,14 L21,14 C21.5522847,14 22,14.4477153 22,15 L22,29 Z"/>
      <rect width="2" height="7" x="6" y="20" className="euiIcon__fillSecondary"/>
      <rect width="2" height="5" x="16" y="22" className="euiIcon__fillSecondary"/>
      <rect width="2" height="10" x="11" y="17" className="euiIcon__fillSecondary"/>
    </g>
  </svg>
);
